// src/pages/Workflows/components/ConfirmarEliminarModal.js

import React from 'react';

export default function ConfirmarEliminarModal({ workflow, onConfirmar, onCancelar, loading }) {
  if (!workflow) return null;

  return (
    <div className="wf-modal-overlay" onClick={onCancelar}>
      <div className="wf-modal" onClick={e => e.stopPropagation()}>
        <div className="wf-modal-header">
          <h3>Eliminar Workflow</h3>
          <button className="wf-modal-close" onClick={onCancelar}>×</button>
        </div>
        <div className="wf-modal-body">
          <p>Tem a certeza que deseja eliminar o workflow <strong>"{workflow.nome}"</strong>?</p>
          <p className="wf-modal-warning">Esta ação não pode ser revertida.</p>
        </div>
        <div className="wf-modal-footer">
          <button className="wf-btn wf-btn-secondary" onClick={onCancelar} disabled={loading}>
            Cancelar
          </button>
          <button className="wf-btn wf-btn-danger" onClick={() => onConfirmar(workflow.id)} disabled={loading}>
            {loading ? 'A eliminar...' : 'Eliminar'}
          </button>
        </div>
      </div>
    </div>
  );
}
